<template>
    <div
        data-test-class="feedback-list-item"
        class="tw-border tw-p-4 tw-border-gray-100 tw-border-solid tw-rounded-lg tw-transform tw-duration-200 hover:tw-scale-105"
    >
        <!-- Header -->
        <div class="feeback-list-item-header">
            <l-profile-picture
                :user="feedback.sender"
                :show-popover-name="true"
                size="xm"
                class="feedback-sender-picture"
                data-test-id="feedback-sender-picture"
            />

            <div class="l-default-margin r-default-margin">
                <span
                    v-if="feedback.badge"
                    v-b-popover.hover.top="{
                        content: feedback.badge.name,
                    }"
                >
                    <img
                        :src="feedback.badge.icon"
                        :alt="feedback.badge.name"
                        class="feedback-list-item-badge"
                    />
                </span>
                <span v-else class="color-grey">
                    <i class="fal fa-angle-right"></i>
                </span>
            </div>

            <l-profile-picture
                v-for="receiver in feedback.thanksNoteReceivers.slice(0, 5)"
                :key="receiver._id"
                :user="receiver"
                :show-popover-name="true"
                size="xm"
                class="team-show-thanks-note-picture"
                data-test-id="feedback-receiver-picture"
            />
            <l-profile-picture
                v-if="feedback.thanksNoteReceivers.length > 5"
                :key="`more-${feedback._id}`"
                :user="{ fallbackText: `+${feedback.thanksNoteReceivers.length - 5}` }"
                size="xm"
                class="team-show-thanks-note-picture"
                data-test-id="feedback-receiver-picture-more"
            />
        </div>
        <!--/Header -->

        <!-- Headline -->
        <div class="feedback-list-headline tw-truncate">
            <span
                v-if="feedback.receiver && feedback.sender._id === feedback.receiver._id"
                class="fake-link"
            >
                {{ $t(`profile.feedback.labelSelfReflection`) }}
            </span>
            <span v-else class="fake-link">
                <span
                    data-test-class="feedback-list-item-sender"
                    :data-test-id="feedback.sender._id"
                >
                    {{
                        $t(`userlist.show.labelFeedbackDirection`, {
                            sender: feedback.sender.firstname,
                            receiver: "",
                        })
                    }}
                </span>
                <span v-for="(receiver, index) in feedback.thanksNoteReceivers" :key="receiver._id">
                    <span
                        data-test-class="feedback-list-item-receiver"
                        :data-test-id="receiver._id"
                    >
                        {{ receiver.firstname || receiver.name }}</span
                    >
                    <span v-if="index < feedback.thanksNoteReceivers.length - 2">, </span>
                    <span v-if="index === feedback.thanksNoteReceivers.length - 2">
                        {{ $t(`userlist.show.labelAnd`) }}
                    </span>
                </span>
            </span>

            <!-- Visibility -->
            <span
                v-show="feedback.visibility !== 'public'"
                class="color-dark l-default-margin"
                data-test-id="feedback-list-item-private"
            >
                <i class="fal fa-lock"></i>
                <span class="l-default-margin-s">{{ $t(`userlist.show.labelPrivate`) }}</span>
            </span>
            <!--/Visibility -->
        </div>
        <!--/Headline -->

        <div class="hr-small"></div>

        <!-- Body -->
        <div class="feedback-list-body">
            <span v-show="feedback.content !== ''" data-test-id="feedback-list-item-content">
                <l-text :text="feedback.content" class="tw-line-clamp-3" />
            </span>
        </div>
        <!--/Body -->

        <div class="hr-small"></div>

        <!-- Footer -->
        <div class="tw-text-gray-400">
            <!-- Date -->
            <span>
                {{ feedback.date | moment("MMM DD, YYYY") }}
            </span>
            <!--/Date -->

            <span class="pull-right">
                <!-- Likes -->
                <span v-if="feedback.likes">
                    <i class="fal fa-thumbs-up"></i>
                    <span class="l-default-margin-s" data-test-id="feedback-list-item-likes">{{
                        feedback.likes
                    }}</span>
                </span>
                <!--/Likes -->

                <!-- Comments -->
                <span v-if="feedback.comments" class="tw-ml-4">
                    <i class="fal fa-comment"></i>
                    <span class="l-default-margin-s" data-test-id="feedback-list-item-comments">{{
                        feedback.comments
                    }}</span>
                </span>
                <!--/Comments -->

                <!-- Shares -->
                <span v-if="feedback.shares" class="tw-ml-4">
                    <i class="fal fa-share-alt"></i>
                    <span class="l-default-margin-s" data-test-id="feedback-list-item-shares">{{
                        feedback.shares
                    }}</span>
                </span>
                <!--/Shares -->
            </span>
        </div>
        <!--/Footer -->
    </div>
</template>

<script>
import LProfilePicture from "@/components/LProfilePicture";
import LText from "@/components/LText";

export default {
    components: {
        LProfilePicture,
        LText,
    },
    props: {
        feedback: {
            type: Object,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.feeback-list-item-header {
    display: flex;
    align-items: center;
}
.feedback-sender-picture {
    opacity: 0.7;
}
.feedback-list-item-badge {
    width: 40px;
    border-radius: 50%;
}

.feedback-list-headline {
    margin-top: 20px;
}
.feedback-list-body {
    min-height: 60px;
}
</style>
